import {createActorContext} from '@xstate/react';

import {rootMachine} from './rootMachine';


const RootMachineContext = createActorContext(rootMachine);

export {RootMachineContext};
